module.exports = __webpack_public_path__ + "a18b958d3b6118695cbe75e126c53394.png";